const Titulo = ({
  texto,
  as = "h1",
  onClick,
  color = "#072531",
  fontSize = 24,
  paddingLeft = 0,
  paddingRight = 0,
  marginTop = 0,
  marginBottom = 0,
  marginLeft = 0,
  marginRight = 0,
  width = "100%",
  fontWeight = "bold",
  textAlign = "start",
}) => {
  const Component = as;
  return (
    <div
      style={{
        width: `${width}`,
        marginTop: `${marginTop}px`,
        marginBottom: `${marginBottom}px`,
        marginLeft: `${marginLeft}px`,
        marginRight: `${marginRight}px`,
        textAlign: `${textAlign}`,
        paddingLeft: `${paddingLeft}px`,
        paddingRight: `${paddingRight}px`,
      }}
    >
      <Component
        style={{
          fontSize: `${fontSize}px`,
          color: `${color}`,
          fontWeight: `${fontWeight}`,
        }}
        onClick={onClick}
      >
        {texto}
      </Component>
    </div>
  );
};

export default Titulo;
